import { CheckOutlined, CopyOutlined, EyeInvisibleOutlined, EyeOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import TcButton from 'components/UI/button/TcButton';
import TcInput from 'components/UI/form/input/TcInput';
import TcForm from 'components/UI/form/TcForm';
import TcFormItem from 'components/UI/form/TcFormItem';
import TcModal from 'components/UI/Modal/TcModal';
import TcTooltip from 'components/UI/Tooltip/TcTooltip';
import { englishNumberOnly } from 'global/default';
import { Map } from 'leaflet';
import { FC, useEffect, useState } from 'react';

interface MapLatLngProps {
  map?: Map;
}

const MapLatLng: FC<MapLatLngProps> = ({ map }) => {
  //state
  const [latLng, setLatLng] = useState<{ lat: string | number; lng: string | number; zoom?: number }>({ lat: 35.56336749, lng: 51.35559082 });
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [showCenterMarker, setShowCenterMarker] = useState<boolean>(false);
  const [copied, setCopied] = useState<boolean>(false);

  //hooks
  const [form] = Form.useForm();

  //effect
  useEffect(() => {
    map?.on('move', (e) => {
      setLatLng({ ...e.target.getCenter(), zoom: e.target.getZoom() });
    });
  }, [map]);
  useEffect(() => {
    showSearch && form.setFieldsValue(latLng);
  }, [showSearch]);
  useEffect(() => {
    if (copied)
      setTimeout(() => {
        setCopied(false);
      }, 3000);
  }, [copied]);

  //functions
  const ToggleShowSearch = () => setShowSearch((prevState) => !prevState);
  const ToggleShowCenterMarker = () => setShowCenterMarker((prevState) => !prevState);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(`lat:${parseFloat(latLng.lat.toString()).toFixed(8)},lng:${parseFloat(latLng.lng.toString()).toFixed(8)},zoom:${latLng.zoom || 10}`);
    setCopied(true);
  };
  const handleChange = (_value: any, values: Record<string, any>) =>
    form.setFieldsValue({ lat: englishNumberOnly(values.lat, false, true), lng: englishNumberOnly(values.lng, false, true) });
  const handleSearch = (values: Record<string, any>) => {
    ToggleShowSearch();
    map?.flyTo([values.lat, values.lng], 17);
    setShowCenterMarker(true);
  };

  return (
    <>
      {showCenterMarker && (
        <div className='absolute top-0 left-0 flex items-center justify-center w-full h-full text-xl text-black pointer-events-none opacity-60 inherit-color'>
          <PlusOutlined />
        </div>
      )}
      <div className='absolute inherit-color flex  z-30 text-[10px] bottom-2 left-4 text-black gap-x-1 cursor-pointer '>
        <TcTooltip title='نمایش نقطه مرکزی'>
          <div className='flex items-center px-1 transition-all duration-500 rounded-full cursor-pointer hover:bg-white hover:shadow-md gap-x-1' onClick={ToggleShowCenterMarker}>
            {!showCenterMarker && <EyeOutlined />}
            {showCenterMarker && <EyeInvisibleOutlined />}
            نقطه مرکز
          </div>
        </TcTooltip>
        <span>|</span>
        <TcTooltip title='جستجو مختصات'>
          <div className='flex items-center px-1 transition-all duration-500 rounded-full cursor-pointer hover:bg-white hover:shadow-md gap-x-1' onClick={ToggleShowSearch}>
            <SearchOutlined />
            مختصات
          </div>
        </TcTooltip>
        <span>|</span>
        <TcTooltip title={copied ? 'متن کپی شد' : 'کپی متن'}>
          <div
            className='flex items-center justify-end px-1 text-black transition-all duration-500 rounded-full cursor-pointer w-52 hover:bg-white hover:shadow-md inherit-color gap-x-1'
            onClick={handleCopyToClipboard}>
            lat:{parseFloat(latLng.lat.toString()).toFixed(8)},lng:{parseFloat(latLng.lng.toString()).toFixed(8)},zoom:{latLng.zoom || 10}
            {!copied && <CopyOutlined className='relative bottom-[2px]' />}
            {copied && <CheckOutlined className='relative bottom-[2px]' />}
          </div>
        </TcTooltip>
      </div>
      <TcModal visible={showSearch} title='جستجو با مختصات جغرافیایی' footer={false} onCancel={ToggleShowSearch}>
        <TcForm form={form} onValuesChange={handleChange} onFinish={handleSearch}>
          <TcFormItem label='عرض جغرافیایی Latitude Y' name='lat'>
            <TcInput />
          </TcFormItem>
          <TcFormItem label='طول جغرافیایی Longitude X' name='lng'>
            <TcInput />
          </TcFormItem>
          <div className='flex justify-end mt-6'>
            <TcButton htmlType='submit' type='primary'>
              جستجو
            </TcButton>
          </div>
        </TcForm>
      </TcModal>
    </>
  );
};

export default MapLatLng;
